import { atom } from "jotai";
import { type LegacyCartResponse } from "@/types/legacy-cart.types";

/** Atom for storing the legacy cart response. Defaults to null if not loaded. */
export const legacyCartAtom = atom<LegacyCartResponse | null>(null);
